import { DashboardAppBaseDataProvider } from './DashboardAppBaseDataProvider';
import { sanitizeObject } from '../../utils/sanitization.utils';
import { Dashboard, Dashboards } from '../../types';
import { getRequestDefaultOptions } from '../../utils/request.utils';

export class DashboardAppNirvanaDataProvider extends DashboardAppBaseDataProvider {
  async createDashboard(): Promise<Dashboard | null> {
    try {
      const response = await this.dependencies.api.clients.Dashboards.createDashboard(
        {
          name: 'sample',
          widgets: [],
        },
        getRequestDefaultOptions()
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async initDashboards(): Promise<Dashboards> {
    try {
      const requestOptions = getRequestDefaultOptions();
      requestOptions.requestTimeout = 3 * 60000;

      const unsanitizedFromBackend = await this.dependencies.api.clients.Dashboards.initDashboards(
        {},
        requestOptions
      ).toPromise();

      const fromBackend = sanitizeObject(unsanitizedFromBackend);

      return {
        status: fromBackend.status,
        targets: fromBackend.targets,
        isPartner: fromBackend.isPartner,
        hasReportsEnabled: fromBackend.hasReportsEnabled,
        dashboards: (fromBackend.dashboards || []).map(dashboard => {
          return {
            id: dashboard.id,
            title: dashboard.name,
            type: dashboard.type,
            timeRange: dashboard.timeRange,
            reportingPeriod: dashboard.reportingPeriod,
            selectedTarget: fromBackend.targets
              .filter(availableCompany => availableCompany.companyId === dashboard.targets[0])
              .pop(), // we know that only one company can be selected at a time
            widgets: (dashboard.widgets || []).map(widget => {
              return {
                id: widget.id,
                type: widget.type,
                x: widget.x,
                y: widget.y,
                width: widget.width,
                height: widget.height,
              };
            }),
            canDrillDown: dashboard.canDrillDown,
            features: dashboard.features,
          };
        }),
      };
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
